

import React from 'react';

const ReasonSection = ({ logos }) => {
  return (
    <section className="reason-section">
      <div className="container">
        <div className="inner-content">
          <h2>Reason to Trust – Proud Members of</h2>
          <div className="logo-row">
            {logos.map((logo, index) => (
              <div className="img-box" key={index}>
                <img src={logo} alt={`Logo ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReasonSection;
